import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  inject,
  ViewChild,
  OnInit,
  DestroyRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';

import { RoleCreateModalComponent, RoleService, Roles } from '../../../index';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ModalAlertComponent } from '@shared/components';
import { ToastAlertService } from '@core/services';
import { UpperCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Component({
  templateUrl: './role-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    UpperCasePipe,
  ],
})
export class RolePageComponent implements OnInit {
  paginatorIntl: MatPaginatorIntl = new MatPaginatorIntl();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private destroyRef = inject(DestroyRef);
  private aletService = inject(ToastAlertService);

  displayedColumns: string[] = ['name', 'rolecode', 'description'];
  dataSource: MatTableDataSource<Roles>;
  fielInput = '';
  private alert = inject(ToastAlertService);

  private dialog = inject(MatDialog);
  private roleService = inject(RoleService);

  constructor() {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.initialize();
  }

  private initialize() {
    this.roleService
      .getRoles()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((request: any) => {
        if (request.code === 10000) {
          this.dataSource = new MatTableDataSource<Roles>(request.reply);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          if (this.paginator) {
            this.paginator._intl.itemsPerPageLabel = 'Registros por página';
            this.paginator._intl.nextPageLabel = 'Página siguiente ';
            this.paginator._intl.previousPageLabel = 'Página anterior';
            this.paginator._intl.firstPageLabel = 'Primera página';
            this.paginator._intl.lastPageLabel = 'Última página';
            // Configuración del texto de la última página
            this.paginator._intl.getRangeLabel = (
              page: number,
              pageSize: number,
              length: number
            ) => {
              if (length === 0 || pageSize === 0) {
                return `0 de ${length}`;
              }
              length = Math.max(length, 0);
              const startIndex = page * pageSize;
              const endIndex =
                startIndex < length
                  ? Math.min(startIndex + pageSize, length)
                  : startIndex + pageSize;
              return `${startIndex + 1} - ${endIndex} de ${length}`;
            };
          }
        } else {
          this.aletService.error(request.detail);
        }
      });
  }

  modalAction(role?: Roles) {
    const dialogActionDetail = this.dialog.open(RoleCreateModalComponent, {
      width: '50%',
      data: role,
      disableClose: true,
    });
    dialogActionDetail
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(request => {
        if (request) {
          this.initialize();
        }
      });
  }

  modalDelete(role: Roles) {
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: role.name,
    });
    dialogDelete
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(request => {
        if (request) {
          this.roleService
            .deleteRole(role.roleid)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: response => {
                if (response.code === 10000) {
                  this.alert.sucess('Rol eliminado');
                  this.initialize();
                } else {
                  this.aletService.error(response.detail);
                }
              },
            });
          console.log('Eliminado');
        } else {
          console.log('Cancelada la eliminacion');
        }
      });
  }
}
